import React, { useEffect, useRef } from 'react';

/**
 * Summernote Lite React 래퍼
 * - jQuery + summernote-lite 는 public/index.html 에서 CDN 로드
 * - onChange: (htmlString) => void
 * - initialValue: 초기 HTML 문자열
 * - height: 에디터 높이(px), 기본 400
 */
const SummernoteEditor = ({ onChange, initialValue = '', height = 400, placeholder = '내용을 입력하세요' }) => {
  const elRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const $ = window.$;
    if (!$ || !$.fn || !$.fn.summernote) return;

    const $el = $(elRef.current);

    $el.summernote({
      lang: 'ko-KR',
      height,
      placeholder,
      tabsize: 2,
      focus: false,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
        ['fontname', ['fontname']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'picture', 'hr']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New',
        'Helvetica Neue', 'Times New Roman',
        '맑은 고딕', '나눔고딕', '나눔명조', '돋움'],
      fontSizes: ['9', '10', '11', '12', '13', '14', '16', '18', '20', '24', '28', '32', '36', '48'],
      callbacks: {
        onChange: (contents) => {
          onChangeRef.current(contents);
        },
        onImageUpload: (files) => {
          const file = files[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = (e) => {
            // 세 번째 인자(콜백)로 삽입된 이미지 width 속성 제거 및 max-width 적용
            $el.summernote('insertImage', e.target.result, function($image) {
              $image.removeAttr('width').removeAttr('height');
              $image.css({ 'max-width': '99%', 'height': 'auto', 'display': 'block' });
              $image.attr('alt', file.name);
            });
          };
          reader.readAsDataURL(file);
        },
      },
    });

    // 초기값 설정
    if (initialValue) {
      $el.summernote('code', initialValue);
    }

    return () => {
      try { $el.summernote('destroy'); } catch {}
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, placeholder]);

  return (
    <div className="summernote-wrapper">
      <textarea ref={elRef} />
    </div>
  );
};

export default SummernoteEditor;
